import { render, staticRenderFns } from "./NoPrivilegeDialog.vue?vue&type=template&id=dcceb0b0&"
import script from "./NoPrivilegeDialog.vue?vue&type=script&lang=js&"
export * from "./NoPrivilegeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports